// Import style
import './style.scss';

export default class Settings {}
